import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import CustomeRadioGroup from './Component.RadioGroup';

const InstrumentResolutionOptions = (props) => {
  console.log(props);
  return (
    <div css={css`
      width: 100%;
    `}>
      <div><b>{props.title}</b></div>
      <CustomeRadioGroup 
        options={props.options}
        onChange={props.onResolutionChange} 
        defaultValue={props.resolutionDefault}
        value={props.resolutionValue}
        disabled={props.disabled}
      />
    </div>
  )
}

export default InstrumentResolutionOptions;